/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import classnames from 'classnames';
import * as React from 'react';

import { Heading, IModuleProps } from '@msdyn365-commerce-modules/utilities';
import { IFarmlandsAccountGenericTileData } from './farmlands-account-generic-tile.data';
import {
    IFarmlandsAccountGenericTileConfig, IFarmlandsAccountGenericTileProps
} from './farmlands-account-generic-tile.props.autogenerated';
import LinksComponent from './components/farmlands-account-generic-tile-links';
import { isShareholder } from '../../common/method/functions';

export interface IAccountGenericTileViewProps extends IFarmlandsAccountGenericTileProps<IFarmlandsAccountGenericTileConfig> {
    AccountGenericTile: IModuleProps;
    className: string;
    heading?: React.ReactNode;
    links?: React.ReactNode;
}

/**
 *
 * AccountGeneric component
 * @extends {React.PureComponent<IFarmlandsAccountGenericTileProps<IFarmlandsAccountGenericTileData>>}
 */
class AccountGenericTile extends React.PureComponent<IFarmlandsAccountGenericTileProps<IFarmlandsAccountGenericTileData>> {
    public render(): JSX.Element {
        const { config, data } = this.props;
        const { className, heading } = config;

        const links = isShareholder(data.cart.result!.cart)
            ? this.props.config.shareholderLinks
            : this.props.config.links;

        const viewProps = {
            ...this.props,
            className: className,
            AccountGenericTile: {
                moduleProps: this.props,
                className: classnames('ms-account-generic-tile', config.className)
            },
            heading: heading && <Heading className='ms-account-generic-tile__heading' headingTag={heading.tag} text={heading.text} />,
            links: links && links.length > 0 && <LinksComponent {...{ links }} />
        };

        return this.props.renderView(viewProps) as React.ReactElement;
    }
}

export default AccountGenericTile;
